// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control {
  font-size: 18px;
  border: 0;
  padding: 2px;
  outline: none;
  box-shadow: none;
  height: auto;
  text-transform: none;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.form-control[read-only] {
  background: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/inline-editor/inline-editor.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/inline-editor/inline-editor.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACCF;ADAE;EACE,gBAAA;ACEJ","sourcesContent":[".form-control {\r\n  font-size: 18px;\r\n  border: 0;\r\n  padding: 2px;\r\n  outline: none;\r\n  box-shadow: none;\r\n  height: auto;\r\n  text-transform: none;\r\n  line-height: 1;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  &[read-only] {\r\n    background: none;\r\n  }\r\n}\r\n",".form-control {\n  font-size: 18px;\n  border: 0;\n  padding: 2px;\n  outline: none;\n  box-shadow: none;\n  height: auto;\n  text-transform: none;\n  line-height: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.form-control[read-only] {\n  background: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
